/**
 * @generated
 * This file was automatically generated and should not be manually edited.
 *
 * Auto-generated enum for: job_runs.status
 *
 * To regenerate: npm run db:codegen
 * Any manual changes will be overwritten on next generation.
 */

/* eslint-disable */
// @ts-nocheck

/**
 * JobRunStatus enum representing allowed values for job_runs.status
 */
export enum JobRunStatus {
  /** Running */
  RUNNING = 'running',
  /** Completed */
  COMPLETED = 'completed',
  /** Failed */
  FAILED = 'failed',
  /** Partial */
  PARTIAL = 'partial',
}
